import React, { useState } from 'react';
import UserAvatar from '../../Atoms/Avatar/UserAvatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useNavigate } from 'react-router-dom';
export const DatascientHeader = ({ logo }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  var navigate = useNavigate();
  const headerStyle = {
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 20px',
    backgroundColor: '#FFF',
    height:'30px',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)' 
  };

  const logoStyle = {
    width: '100px', 
    height: '40px',
    cursor:'pointer',
  };

  const rightCornerStyle = {
    marginLeft: 'auto',
    cursor:'pointer'
  };

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleProfileClick = () => {
    
    setAnchorEl(null);
  };
  
  const handleSettingsClick = () => {
  
    setAnchorEl(null);
  };
  
  const handleLogoutClick = () => {
    localStorage.clear();
  
      // Navigate to the signup page (change '/signup' to your signup route)
      navigate('/login');
    setAnchorEl(null);
  };
  

  return (
    <div style={headerStyle}>
      <div>
        <img src={logo} alt="Logo" style={logoStyle}  onClick={()=>{
           navigate('/dashboard');
        }}/>
      </div>
      <div style={rightCornerStyle} onClick={handleAvatarClick} >
        <UserAvatar text={localStorage.getItem('org_id')||"O"} />
        </div>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
      
          sx={{margin:'auto'}}
        >
          {/* {/* <MenuItem onClick={handleProfileClick}>Profile</MenuItem> */}
          <MenuItem disabled sx={{fontSize:'14px',textAlign:'center'}} >{localStorage.getItem('org_id')}</MenuItem> 
          <MenuItem onClick={handleLogoutClick} sx={{textAlign:'center',justifyContent:'center'}}>Logout</MenuItem>
        </Menu>
  
    </div>
  );
};

export default DatascientHeader;
